/**
 * bandwidth-governor-analytics.ts -- PostHog event constants for bandwidth governor.
 *
 * Separate from posthog/constants.ts which holds feature flag keys (not event names).
 * Per rule: stay-in-scope (ai.knowledge/global) -- keep analytics events with their
 * subsystem, not in the shared feature-flag constants file.
 * Per rule: code-comments-required (ai.knowledge/global) -- document why separate file.
 */

/** PostHog analytics event names for bandwidth governor state transitions and actions. */
export const BANDWIDTH_GOVERNOR_ANALYTICS = {
  /** Emitted when governor transitions between normal/congested (edge-only, not every tick). */
  STATE_CHANGED: 'bandwidth_governor_state_changed',
  /** Emitted when governor applies a degrade/recover action to a device. */
  ACTION_TAKEN: 'bandwidth_governor_action_taken',
  /** Emitted when the user toggles manual low-bandwidth mode on/off. */
  MANUAL_MODE_TOGGLED: 'bandwidth_governor_manual_mode_toggled'
} as const;
